module.exports = __webpack_public_path__ + "static/media/Южный Лес вечер.71b0cc6c.jpg";